function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 17,
  height: 17
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4.26a.463.463,0,0,1,.742-.108l.54.358a.751.751,0,0,1,.27.394.767.767,0,0,1-.169.538l-5.905,9.5c-.135.215-.236.358-.337.5a.979.979,0,0,1-.337.323,1.541,1.541,0,0,1-.337.179,1.15,1.15,0,0,1-.371.072,1.144,1.144,0,0,1-.641-.215,3.126,3.126,0,0,1-.742-.788L.076,6.711a.379.379,0,0,1-.1-.358.789.789,0,0,1,.169-.287l.641-.573a.457.457,0,0,1,.3-.143.59.59,0,0,1,.3.143L4.328,7.965Z",
  transform: "translate(3 3)"
});

function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    className: "box",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      stroke: "#707070"
    }
  }, _ref2, _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.bc57c15a.svg";
export { ForwardRef as ReactComponent };